import dayjs from 'dayjs'
import areaCodeCN from '~/static/json/areaCodeCN.json'
import areaCodeEN from '~/static/json/areaCodeEN.json'
// 加法
export const add = require('lodash/add')
// 减法
export const subtract = require('lodash/subtract')
// 乘法
export const multiply = require('lodash/multiply')
// 除法
export const divide = require('lodash/divide')
// 生成随机数
export const random = require('lodash/random')
// 数值四舍五入
export const round = require('lodash/round')
// 数值向上舍入
export const ceil = require('lodash/ceil')
// 数值向下舍入
export const floor = require('lodash/floor')
// 根据条件取最大值
export const maxBy = require('lodash/maxBy')
// 根据条件求和
export const sumBy = require('lodash/sumBy')
// 对象合并
export const assign = require('lodash/assign')
// 深拷贝
export const cloneDeep = require('lodash/cloneDeep')
// 创建防抖函数
export const debounce = require('lodash/debounce')
// 创建节流函数
export const throttle = require('lodash/throttle')
// 判断是否为object对象的直接或继承属性
export const hasIn = require('lodash/hasIn')
// 获取IP地址
export function getIP (req = {}) {
  // return '220.255.1.166'
  // return '180.164.180.131'
  const reqList = [
    'x-forwarded-for',
    'Proxy-Client-IP',
    'WL-Proxy-Client-IP',
    'HTTP_CLIENT_IP'
  ]
  for (let i = 0; i < reqList.length; i++) {
    const currItem = req?.headers[reqList[i]]
    if (currItem && currItem != 'unknown') return currItem?.split(',')[0]
  }
  const connAddress = req?.connection?.remoteAddress
  if (connAddress && connAddress != 'unknown')
    return connAddress?.split(',')[0]
  return ''
}
// 获取今天的日期（年月日时分秒）
export function getSeconds (value = '') {
  const pattern = 'YYYY-MM-DD HH:mm:ss'
  return value ? dayjs(value).format(pattern) : dayjs().format(pattern)
}
// 获取今天的日期（年月日）
export function getToday (value = '', connect = '-') {
  const pattern = `YYYY${connect}MM${connect}DD`
  return value ? dayjs(value).format(pattern) : dayjs().format(pattern)
}
// 获取今天的日期（年月）
export function getYearMonth (value = '', connect = '-') {
  const pattern = `YYYY${connect}MM`
  return value ? dayjs(value).format(pattern) : dayjs().format(pattern)
}
// 获取今天的日期（月日）
export function getMonthDay (value = '', connect = '-') {
  const pattern = `MM${connect}DD`
  return value ? dayjs(value).format(pattern) : dayjs().format(pattern)
}
// 获取今天的日期（月日,时分秒）
export function getMonthDayHour (value = '', connect = '-') {
  const pattern = `MM${connect}DD HH:mm:ss`
  return value ? dayjs(value).format(pattern) : dayjs().format(pattern)
}
// 获取今天的日期（月日,时分）
export function getMonthDayMinute (value = '', connect = '-') {
  const pattern = `MM${connect}DD HH:mm`
  return value ? dayjs(value).format(pattern) : dayjs().format(pattern)
}
// 获取N个月前的日期（年月日）
export function getLastNMonth (value = 1, connect = '-') {
  return dayjs()
    .subtract(value, 'month')
    .format(`YYYY${connect}MM${connect}DD`)
}
// 获取N个月前的日期（年月）
export function getPrevNMonth (value = 1, connect = '-') {
  return dayjs().subtract(value, 'month').format(`YYYY${connect}MM`)
}
// 获取指定N年前的日期
export function getAppointNYear (date = '', value = 1, connect = '-') {
  return dayjs(date || new Date())
    .subtract(value, 'years')
    .format(`YYYY${connect}MM${connect}DD`)
}
// 获取指定N个月前的日期
export function getAppointNMonth (date = '', value = 1, connect = '-') {
  return dayjs(date || new Date())
    .subtract(value, 'months')
    .format(`YYYY${connect}MM${connect}DD`)
}
// 获取指定N个月前的日期（年月日时分秒）
export function getAppointNMonthHour (date = '', value = 1, connect = '-') {
  return dayjs(date || new Date())
    .subtract(value, 'months')
    .format(`YYYY${connect}MM${connect}DD HH:mm:ss`)
}
// 获取指定N个日前的日期
export function getAppointNDay (date = '', value = 1, connect = '-') {
  return dayjs(date || new Date())
    .subtract(value, 'day')
    .format(`YYYY${connect}MM${connect}DD HH:mm:ss`)
}
// 计算滚动条宽度
export function getScrollBarWidth () {
  const [outer, inner] = [
    document.createElement('div'),
    document.createElement('div')
  ]
  outer.style.overflow = 'scroll'
  document.body.appendChild(outer)
  outer.appendChild(inner)
  const scrollBarWidth = outer.offsetWidth - inner.offsetWidth
  document.body.removeChild(outer)
  return scrollBarWidth
}
// 滚动至页面指定位置
export function toSpecifyLocation (str = '') {
  const topDistance = subtract(
    document.getElementById(str)?.offsetTop || 0,
    128
  )
  window?.scrollTo({ top: topDistance, behavior: 'instant' })
}
// 获取语言（参数：国际/国内版，路由，cookies，浏览器语言，语言列表）
export function getLanguage (
  isForeign = true,
  params = {},
  cookie = {},
  browserList = '',
  langList = []
) {
  if (!isForeign) return 'zh-cn' // 国内版，语言为简体中文
  // 第一步：获取浏览器地址栏语言参数，校验该语言是否存在于语言列表中
  let currLang = (params?.lang || '')?.toLowerCase()
  currLang = ['zh-hk', 'zh-tw'].includes(currLang) ? 'zh' : currLang
  if (currLang && langList.includes(currLang)) return currLang
  // 第二步：获取cookies中的语言参数
  const cookLang = (cookie.get('LanguageCode') || '')?.toLowerCase()
  if (cookLang && langList.includes(cookLang)) return cookLang
  // 第三步：获取浏览器的语言
  const browserLang = browserList?.split(',')[0]?.toLowerCase() || ''
  if (browserLang && langList.includes(browserLang)) return browserLang
  // 第四步：在不满足以上步骤的情况下，默认为英语语言
  return 'en'
}
// 获取用户所在的国家信息（参数：一个对象，当前语言）
export function getMyCountry (obj = {}, lang = 'en') {
  const key = Object.keys(obj)[0]
  const retrieval = lang != 'zh-cn' ? areaCodeEN : areaCodeCN
  for (let i = 0; i < retrieval.length; i++) {
    const result = retrieval[i]?.data?.find(each => each[key] == obj[key])
    if (!result) continue
    return result
  }
  return {} // 未找到结果，返回空对象
}
// 头部——菜单栏高亮某一项
export function menuLight (
  arr = [],
  scrollDistance = 0,
  exclusionDistance = 128
) {
  for (let i = 0; i < arr?.length; i++) {
    if (!arr[i]?.dom) continue
    const modularDom = document.getElementById(arr[i]?.dom)
    const [modularTop, modularHeight] = [
      subtract(modularDom?.offsetTop || 0, exclusionDistance),
      subtract(modularDom?.offsetHeight || 0, exclusionDistance)
    ]
    if (
      scrollDistance >= modularTop &&
      scrollDistance <= add(modularTop, modularHeight)
    )
      return arr[i]?.code
  }
  return 0
}
// 首页——多空情绪——横条闪动
export function flashAnimate (arr = []) {
  const [allLen, randList, tempArr] = [arr?.length, [], []]
  if (!allLen) return arr // 数组内无数据时，不执行后续操作
  for (let i = 0; i < allLen; i++) arr[i].active = false // 取消所有横条的高亮效果
  while (randList.length <= floor(allLen / 2)) {
    // 随机生成几个不重复的数字
    const [currIdx, increase] = [
      floor(Math.random() * (allLen - 1)),
      floor(Math.random() * 21) - 10
    ] // 数组下标随机数、-10~10范围内随机数
    randList.push({ currIdx, ripple: increase / 100 })
  }
  for (let i = 0; i < randList.length; i++) {
    const item = randList[i]
    if (tempArr.includes(item.currIdx)) continue // 下标重复，不执行后续操作
    tempArr.push(item.currIdx)
    let { red: hLeft = 0, green: hRight = 0 } = arr[item.currIdx]
    if (hLeft > 10) {
      hLeft = round(add(Number(hLeft), item.ripple), 2)
      hRight = round(subtract(100, hLeft), 2)
    } else {
      hRight = round(add(Number(hRight), item.ripple), 2)
      hLeft = round(subtract(100, hRight), 2)
    }
    hLeft = hLeft >= 100 ? 100 : hLeft <= 0 ? 0 : hLeft
    hRight = hRight >= 100 ? 100 : hRight <= 0 ? 0 : hRight
    assign(arr[item.currIdx], { red: hLeft, green: hRight, active: true })
  }
  return arr
}
// 首页——持仓分布——处理接口返回的数据
export function buySellProfit (dataArr = [], yArr = []) {
  const [xScale, y, yScale] = [[], [], []]
  let cutTxt = '' // 分割数字
  dataArr?.forEach((item) => {
    item.rate = Number(item.rate?.match(/[\d.]+/g)[0] || 0)
    xScale.push(item.rate)
    yScale.push(`${item.low}~${item.high}`)
  })
  for (let i = 0; i < yArr?.length; i++) {
    // 计算右侧y轴数字
    if (i % 3) continue
    y.push(yArr[i])
  }
  if (yArr?.length) cutTxt = yArr[floor(yArr.length / 2)] // 计算分割数字
  return {
    xScale,
    y,
    yScale,
    cutTxt
  }
}
// 首页——持仓分布——计算x轴数据
function getXLabel (start, end, step) {
  return Array.from(
    { length: ceil((end - start) / step.toFixed(2)) },
    (e, i) => start + multiply(i, step)
  )
}
// 首页——持仓分布——处理图表需要的数据
export function dealPosiData (openRate = {}, priceStep = [], stepLen = 3) {
  const { SellWin = [], buyWin = [], SellLoss = [], BuyLoss = [] } = openRate
  const {
    xScale: sellWinX,
    yScale: sellWinY,
    y: yArr,
    cutTxt
  } = buySellProfit(SellWin, priceStep)
  const { xScale: buyWinX, yScale: buyWinY } = buySellProfit(buyWin)
  const { xScale: sellLossX, yScale: sellLossY } = buySellProfit(SellLoss)
  const { xScale: buyLossX, yScale: buyLossY } = buySellProfit(BuyLoss)
  const [swMax, bwMax, slMax, blMax, priceItem] = [
    maxBy(SellWin, 'rate'),
    maxBy(buyWin, 'rate'),
    maxBy(SellLoss, 'rate'),
    maxBy(BuyLoss, 'rate'),
    []
  ] // 根据指定字段查找最大值
  const xStep =
    floor(
      (maxBy([swMax, bwMax, slMax, blMax], 'rate')?.rate || stepLen) / stepLen
    ) + 1 // x轴数字步长
  for (let i = 0; i < priceStep?.length - 1; i++)
    priceItem.push(`${priceStep[i + 1]}~${priceStep[i]}`)
  priceItem?.slice(0, ceil(priceItem.length / 2))?.forEach((item, index) => {
    // 上方两个图表，数据条数不足时，补0
    if (item != sellWinY[index]) {
      sellWinX.splice(index, 0, 0)
      sellWinY.splice(index, 0, item)
    }
    if (item != buyLossY[index]) {
      buyLossX.splice(index, 0, 0)
      buyLossY.splice(index, 0, item)
    }
  })
  priceItem?.slice(ceil(priceItem.length / 2))?.forEach((item, index) => {
    // 下方两个图表，数据条数不足时，补0
    if (item != sellLossY[index]) {
      sellLossX.splice(index, 0, 0)
      sellLossY.splice(index, 0, item)
    }
    if (item != buyWinY[index]) {
      buyWinX.splice(index, 0, 0)
      buyWinY.splice(index, 0, item)
    }
  })
  return {
    sellWinXScale: sellWinX?.reverse()?.map(item => (item != 0 ? -item : 0)),
    sellWinYScaleArray: sellWinY?.reverse(),
    buyWinXScale: buyWinX?.map(item => (item != 0 ? -item : 0)),
    buyWinYScaleArray: buyWinY,
    sellLossXScale: sellLossX,
    sellLossYScaleArray: sellLossY,
    buyLossXScale: buyLossX?.reverse(),
    buyLossYScaleArray: buyLossY?.reverse(),
    x_coordinate: [
      ...getXLabel(multiply(-xStep, stepLen), 0, xStep),
      ...getXLabel(0, multiply(xStep, stepLen) + 1, xStep)
    ],
    y_coordinate: yArr,
    cutTxt
  }
}
// 语言zh-cn、zh-tw、zh-hk特殊处理
export function langFn (str = 'en') {
  return str?.includes('-')
    ? `${str?.split('-')[0]}-${str?.split('-')[1]?.toUpperCase()}`
    : str
}

export function matomofn (event, obj, state, cookie) {
  // matomo埋点
  const bfp = cookie.get('wiki-bfp') ? cookie.get('wiki-bfp') : '822ca7b3261a0b2ec10c8cdabfb5a0ea'
  let base = `999,0,2,999,0,${bfp},0`
  if (state.fullHost.includes('wikifx')) {
    base = `999,0,2,999,0,${bfp},0`
  } else if (state.myCountry == 'cn') {
    base = `999,0,1,999,1,${bfp},1`
  } else {
    base = `999,0,2,999,0,${bfp},0`
  }
  let str = ''
  for (const key in obj) {
    str += `&${key}=${obj[key]}`
  }
  console.log(
    `userid=${state.simpleUser?.userId}&basicdata=${base}&Langugecode=${state.locale}&countryCode=${state.countryCode}${str}`
  )
  window?._paq?.push([
    'trackEvent',
    `userid=${state.simpleUser?.userId}&basicdata=${base}&Langugecode=${state.locale}&countryCode=${state.countryCode}${str}`,
    'Click',
    event
  ])
  console.log(event, '有埋点了')
}

function getAppUserAgentInfo (userAgent = '') {
  const userAgents = String(userAgent || (process.client ? navigator.userAgent : ''))
  const basicData = userAgents.match(/"BasicData"\s*:\s*"([^"]*)"/)?.[1] || ''
  const basicDataParts = basicData.split(',')
  const appVersion = Number(String(basicDataParts[3] || '').replace(/\D/g, ''))
  const appType = basicDataParts[2]

  return {
    isNewApp: appType === '1000' ? appVersion >= 210 : appType === '3' && appVersion >= 402
  }
}

// 判断当前 App 版本是否支持隐藏加载进度
export function shouldHideProgress (userAgent = '') {
  return getAppUserAgentInfo(userAgent).isNewApp
}

// 设置新版 App 的顶部导航栏
export function setAppBar (config, userAgent = '') {
  if (!process.client) return false

  const params = JSON.stringify(config)
  const appUserAgent = String(userAgent || navigator.userAgent || '')
  const isIos = /"wikistock"\s*:\s*"ios"/i.test(appUserAgent)

  try {
    if (isIos && window.setAppBar && typeof window.setAppBar.postMessage === 'function') {
      window.setAppBar.postMessage(params)
      return true
    }

    if (typeof window.Communication === 'function') {
      window.Communication('setAppBar', params)
      return true
    }

    if (window.flutter_inappwebview && typeof window.flutter_inappwebview.callHandler === 'function') {
      window.flutter_inappwebview.callHandler('setAppBar', params)
      return true
    }
  } catch (error) {
    console.log('setAppBar failed', error)
  }

  return false
}

export function uuid () {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}
